import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-4">
      <ol className="flex items-center flex-wrap gap-1 text-sm text-foreground-500">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className="flex items-center gap-1">
              {index > 0 && (
                <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center text-foreground-400"></i>
              )}
              {item.path && !isLast ? (
                <Link
                  to={item.path}
                  className="text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? 'text-foreground-800 font-medium' : 'text-foreground-500'}>
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}